import React, { useState, useEffect } from 'react';

const RecentSearches = () => {
  const [searches, setSearches] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // For this prototype, we'll use localStorage to track recent searches
  // In a real implementation, this would likely be stored in the database and fetched via API
  useEffect(() => {
    loadRecentSearches();
  }, []);

  const loadRecentSearches = () => {
    setIsLoading(true);
    try {
      // Get searches from localStorage
      const storedSearches = localStorage.getItem('icd_recent_searches');
      if (storedSearches) {
        setSearches(JSON.parse(storedSearches));
      }
    } catch (error) {
      console.error('Error loading recent searches:', error);
      // If there's an error parsing JSON, reset the searches
      localStorage.removeItem('icd_recent_searches');
      setSearches([]);
    } finally {
      setIsLoading(false);
    }
  };

  const clearAllSearches = () => {
    localStorage.removeItem('icd_recent_searches');
    setSearches([]);
  };

  const removeSearch = (index) => {
    const updatedSearches = [...searches];
    updatedSearches.splice(index, 1);
    setSearches(updatedSearches);
    localStorage.setItem('icd_recent_searches', JSON.stringify(updatedSearches));
  };

  // This function would be called when clicking on a search term
  const performSearch = (searchTerm) => {
    // In a real implementation, this would navigate to the search page and execute the search
    console.log('Searching for:', searchTerm);
    // For now, just redirect to the search page
    window.location.href = `/?search=${encodeURIComponent(searchTerm)}`;
  };

  if (isLoading) {
    return <div className="loading">Loading recent searches...</div>;
  }

  return (
    <div className="recent-searches-container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Recent Searches</h2>
        {searches.length > 0 && (
          <button 
            className="btn btn-outline-danger btn-sm"
            onClick={clearAllSearches}
          >
            <i className="fas fa-trash-alt mr-1"></i> Clear All
          </button>
        )}
      </div>
      
      {searches.length === 0 ? (
        <div className="alert alert-info">
          <i className="fas fa-info-circle mr-1"></i> You haven't performed any searches yet.
        </div>
      ) : (
        <>
          <p className="text-muted mb-3">
            Your {searches.length} most recent searches are stored locally on your device.
          </p>
          
          <div className="list-group">
            {searches.map((search, index) => (
              <div key={index} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                <div className="search-item-content" onClick={() => performSearch(search.term)}>
                  <div>
                    <strong>{search.term}</strong>
                  </div>
                  <small className="text-muted">
                    <i className="fas fa-clock mr-1"></i>
                    {new Date(search.timestamp).toLocaleString()} 
                    {search.results > 0 && (
                      <span className="ml-2">
                        <i className="fas fa-list mr-1"></i>
                        {search.results} results
                      </span>
                    )}
                  </small>
                </div>
                <button 
                  className="btn btn-sm btn-link text-danger" 
                  onClick={() => removeSearch(index)}
                  title="Remove from history"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            ))}
          </div>
        </>
      )}
      
      <div className="card mt-4">
        <div className="card-header">
          <h5 className="mb-0">About Recent Searches</h5>
        </div>
        <div className="card-body">
          <p className="card-text">
            Your recent searches are stored locally in your browser. This information is not sent to
            any server and is only used to make it easier for you to access your previous searches.
          </p>
          <p className="card-text mb-0">
            <i className="fas fa-shield-alt text-success mr-1"></i>
            Your privacy is important to us.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RecentSearches; 
